<template>
  <el-container>
    <el-header class="custom-header">
      <span class="text-muted">
        {{
          title
        }}
      </span>
    </el-header>
    <el-main>
      <slot name="header" />
      <el-divider v-if="hasLine" />
      <slot name="main" />
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    title: {
      type: String,
      require: false,
      default: ''
    },
    hasLine: {
      type: Boolean,
      require: false,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
.el-container {
  margin-bottom: 22px;
}

.el-header.custom-header {
  background-color: #d7d7d7;
  height: 30px !important;
  line-height: 30px !important;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0,0,0,0.3);
  margin-bottom: 12px;
}

.text-muted {
  color: #000000;
}

.el-main {
  background-color: white;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>
